import { APP_API_URL, APP_API_URL_V2 } from '../../utils/xhr-instance';
import axiosInstance, { axiosInstanceV2 } from '../axios';
export const CREATE_GROUP_API_URL = `${APP_API_URL}/product-group/create`;

export async function getPackagingList(params) {
	const token = localStorage.getItem('authToken');
	try {
		const { data } = await axiosInstance.get(`${APP_API_URL}/product/packaging-list`, {
			params,
			headers: {
				Authorization: `Bearer ${token}`,
			},
		});
		return data.data;
	} catch (error) {
		throw error;
	}
}

export async function getProductList(params) {
	const token = localStorage.getItem('authToken');
	try {
		const { data } = await axiosInstance.get(`${APP_API_URL}/product/getAllProducts`, {
			params,
			headers: {
				Authorization: `Bearer ${token}`,
			},
		});
		return data.data;
	} catch (error) {
		throw error;
	}
}

export async function getProducts(params) {
	const token = localStorage.getItem('authToken');
	try {
		const { data } = await axiosInstanceV2.get(`${APP_API_URL_V2}/inventory/products/list`, {
			params,
			headers: {
				Authorization: `Bearer ${token}`,
			},
		});
		return data.data;
	} catch (error) {
		throw error;
	}
}

export async function getProductDetails(id) {
	const token = localStorage.getItem('authToken');
	try {
		const { data } = await axiosInstanceV2.get(
			`${APP_API_URL_V2}/inventory/products/details/${id}`,
			{
				headers: {
					Authorization: `Bearer ${token}`,
				},
			},
		);
		return data.data.product_details;
	} catch (error) {
		throw error;
	}
}

export async function getProductBatchList(params) {
	const token = localStorage.getItem('authToken');
	try {
		const { data } = await axiosInstance.get(`${APP_API_URL}/product/product-batch`, {
			params,
			headers: {
				Authorization: `Bearer ${token}`,
			},
		});
		return data.data;
	} catch (error) {
		throw error;
	}
}

export const deleteBatch = async (body) => {
	try {
		let API_URL = `${APP_API_URL}/product/product-batch/delete`;
		const token = localStorage.getItem('authToken');
		const res = await axiosInstance.delete(API_URL, {
			data: body,
			headers: {
				'Content-Type': 'application/json',
				Authorization: `Bearer ${token}`,
			},
		});
		console.log(res);
		if (res?.data?.success) {
			return res?.data;
		} else {
			return res;
		}
	} catch (err) {
		throw err;
	}
};

export async function fetchProductDetails(id, params) {
	try {
		const token = localStorage.getItem('authToken');
		const { data } = await axiosInstance.get(`${APP_API_URL}/product/get-product-details/${id}`, {
			params,
			headers: {
				Authorization: `Bearer ${token}`,
			},
		});
		return data.data;
	} catch (error) {
		throw error;
	}
}

export const createProductGroup = async (formBody) => {
	try {
		let API_URL = CREATE_GROUP_API_URL;
		const token = localStorage.getItem('authToken');
		const res = await axiosInstance.post(API_URL, formBody, {
			headers: {
				'Content-Type': 'application/json',
				Authorization: `Bearer ${token}`,
			},
		});
		if (res?.data?.success) {
			return res?.data;
		} else {
			return res;
		}
	} catch (error) {
		throw error;
	}
};

export const CREATE_CATOGERY_API_URL = `${APP_API_URL}/product-category/create`;

export const createProductCategory = async (formBody) => {
	try {
		let API_URL = CREATE_CATOGERY_API_URL;
		const token = localStorage.getItem('authToken');
		const res = await axiosInstance.post(API_URL, formBody, {
			headers: {
				'Content-Type': 'application/json',
				Authorization: `Bearer ${token}`,
			},
		});

		if (res?.data?.success) {
			return res?.data;
		} else {
			return res;
		}
	} catch (err) {
		throw err;
	}
};

export const exportProducts = async (params) => {
	try {
		const { type, mime_type, is_sample } = params;
		const token = localStorage.getItem('authToken');
		const { data } = await axiosInstanceV2.get(
			`${APP_API_URL_V2}/inventory/products/export/${type}/${mime_type}/${is_sample}`,
			{
				headers: {
					Authorization: `Bearer ${token}`,
				},
			},
		);
		return data.data;
	} catch (error) {
		throw error;
	}
};
